






















































import { computed, defineComponent } from '@vue/composition-api';
import { MaxCreativeLimit } from '@tt4b/ttam-enums';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

const name = 'ttam-ad-list-header';

export default defineComponent({
  name,
  components: { QuestionTooltip },

  props: {
    isShowCreativeTypeCount: { type: Boolean, default: true },
    isSupportCarousel: { type: Boolean, default: true },
    isShowCatalogImage: { type: Boolean, default: false },
    isShowCatalogCarousel: { type: Boolean, default: false },
    isShowSingleImage: { type: Boolean, default: true },
    isShowSmartCreative: { type: Boolean, default: true },
    isShowCatalogVideo: { type: Boolean, default: true },
    singleImageCount: { type: Number, default: 0 },
    singleVideoCount: { type: Number, default: 0 },
    carouselImageCount: { type: Number, default: 0 },
    catalogVideoCount: { type: Number, default: 0 },
    catalogImageCount: { type: Number, default: 0 },
    smartCreativeCount: { type: Number, default: 0 },
    catalogCarouselCount: { type: Number, default: 0 },
    maxCount: { type: Number, default: MaxCreativeLimit },
  },

  setup(props) {
    const totalCount = computed(
      () =>
        props.singleImageCount +
        props.singleVideoCount +
        props.carouselImageCount +
        props.catalogVideoCount +
        props.smartCreativeCount +
        props.catalogImageCount +
        props.catalogCarouselCount,
    );
    return {
      name,
      totalCount,
    };
  },
});
